import {
  CreateOmitBaseEntityKeys,
  IBaseEntity,
  UpdateOmitBaseEntityKeys,
} from "./../system/BaseEntity";

export enum ConditionType {
  Field,
  MarketingGroup,
  ContactType,
  LeadScore,
  FormName,
}

export interface INurtureCampaignCondition extends IBaseEntity {
  type: ConditionType;
  fieldName: string;
  operator: string;
  value: string;
  nurtureCampaignRuleId: string;
}

export interface NurtureCampaignConditionCreate
  extends Omit<
    INurtureCampaignCondition,
    CreateOmitBaseEntityKeys | "nurtureCampaignRuleId"
  > {}

export interface NurtureCampaignConditionUpdate
  extends Omit<INurtureCampaignCondition, UpdateOmitBaseEntityKeys | "id"> {
  id?: string;
}
